import React from "react";
import { Star, Quote, ShieldCheck } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "أحمد م.",
    role: "طالب في وارسو",
    quote:
      "كنت ضائع بين معلومات الإنترنت. بعد الاستشارة عرفت بالضبط ما يجب أن أفعله ومن أين أبدأ.",
  },
  {
    name: "سارة خ.",
    role: "موظفة في كراكوف",
    quote:
      "الدعم الكامل وفّر عليّ وقت كثير وقلق أكثر. أخيراً تعاملت مع ناس يفهمون وضعي.",
  },
  {
    name: "يوسف ع.",
    role: "حالة مركّبة في بوزنان",
    quote:
      "قالوا لي بصراحة إن حالتي تحتاج دعم كامل ولماذا، وهذا ما كنت أحتاجه بالضبط.",
  },
];

export default function Trust() {
  return (
    <section
      id="trust"
      className="py-20 lg:py-24 bg-slate-50"
      data-testid="trust-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-start max-w-2xl mb-12">
          <div className="text-emerald-700 text-sm font-semibold mb-3">
            الثقة قبل كل شيء
          </div>
          <h2 className="font-tajawal text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
            نوجّهك بناءً على وضعك الحقيقي — لا على نصائح الإنترنت
          </h2>
          <p className="mt-3 text-base md:text-lg text-slate-600">
            نساعد من يقيم حالياً في بولندا أو يخطط للعيش فيها على اختيار
            مسار الإقامة المناسب، مع شفافية كاملة في ما تحتاجه وما لا
            تحتاجه.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              className="bg-white border border-slate-200 rounded-2xl p-7 shadow-sm relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-8 h-8 text-emerald-200 absolute top-5 left-5 rotate-180" />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, idx) => (
                  <Star
                    key={idx}
                    className="w-4 h-4 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>
              <blockquote className="text-slate-800 leading-relaxed text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-slate-100">
                <div className="font-tajawal font-bold text-slate-900">
                  {t.name}
                </div>
                <div className="text-xs text-slate-500">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Trust box */}
        <div
          className="mt-10 bg-white border-2 border-emerald-200 rounded-2xl p-6 lg:p-7 flex flex-col md:flex-row items-start gap-5"
          data-testid="trust-box"
        >
          <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center flex-shrink-0">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <div>
            <h3 className="font-tajawal text-lg font-bold text-slate-900 mb-1">
              ليست كل حالة تحتاج دعماً كاملاً
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              إذا كانت الاستشارة كافية لحالتك، سنخبرك بذلك مباشرة. وإذا كان
              الدعم الكامل هو الخيار الأفضل، سنوضح لك لماذا قبل أي قرار.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
